<template>
  <div>
    <label class="bm-label">{{ labelVal }}</label>
    <bm-tooltip v-if="tooltipVal" bottom>
      <span>{{ tooltipVal }}</span>
    </bm-tooltip>
    <bm-read-only-field v-show="readOnly">
      {{ radioLabel }}
    </bm-read-only-field>
    <v-radio-group
      v-show="!readOnly"
      ref="radiogroup"
      class="bm-radio-group"
      :value="value"
      v-bind="$attrs"
      @change="emit('update:value', $event)"
    >
      <slot></slot>
    </v-radio-group>
  </div>
</template>

<script lang="ts">
export default {
  name: "BmRadioGroup",
};
</script>

<script setup lang="ts">
import BmTooltip from "@/components/controls/input/BmTooltip.vue";
import BmReadOnlyField from "@/components/controls/input/BmReadOnlyField.vue";
import { useBmLabelled } from "@/components/controls/input/mixins/BmLabelled";
import type Key from "@/app/types/common/key";
import { computed, onMounted, ref } from "vue";

interface BmRadioGroupProps {
  label?: string | null;
  tooltip?: string | null;
  t?: Key;
  dataQa?: object | string;
  value?: any;
  readOnly?: boolean;
}

interface BmRadioGroupEvents {
  (event: "update:value", value: any): void;
}

const props = withDefaults(defineProps<BmRadioGroupProps>(), {
  label: null,
  tooltip: null,
});

const emit = defineEmits<BmRadioGroupEvents>();

const { labelVal, tooltipVal } = useBmLabelled(() => props);

const isMounted = ref(false);
const radiogroup = ref<any>(null);

/**
 * Gets the label of the currently selected child radio.
 */
const radioLabel = computed(() => {
  if (isMounted.value) {
    for (const radio of radiogroup.value?.items ?? []) {
      if (radio.value === props.value) {
        return radio.label;
      }
    }
  }
  return "";
});

onMounted(() => {
  isMounted.value = true;
});
</script>

<style lang="sass">
@import "src/sass/typography"

.bm-label
  @include bm-field-label
</style>
